import { Button, Form, Input, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { Option } from 'antd/es/mentions';
import React, { useEffect } from 'react';
import { useTransaction } from './TransactionStore';
import { useForm } from 'antd/es/form/Form';

function Edit(props) {
    let { ed, updateTransaction, getKontr, kontr } = useTransaction()
    useEffect(() => {
        getKontr();
    }, [getKontr]);
    let [form] = useForm()
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed, form])
    return (
        <Form layout='vertical' onFinish={updateTransaction} form={form}>
            <Form.Item name={'id'} label="ID">
                <Input type='number' disabled />
            </Form.Item>
            <Form.Item name={'customer_id'} label="Kontragent">
                <Select options={kontr.map((item) => ({ value: item.id, label: (item.kontr_type === 'customer' ? "Mijoz" : "Sotuvchi") + " | " + item.first_name + ' ' + item.last_name }))} />
            </Form.Item>
            <Form.Item name={'transaction_type'} label="Turi">
                <Select>
                <Option value='debit'>Debet</Option>
                <Option value='credit'>Kredit</Option>
            </Select>
        </Form.Item>
        <Form.Item name={'amount'} label="Summa">
            <Input type='number' />
        </Form.Item>
        <Form.Item name={'currency'} label="Valyuta">
            <Select>
                <Option value='UZS'>Sum</Option>
                <Option value='USD'>Dollar</Option>
            </Select>
        </Form.Item>
        <Form.Item name={'status'} label="Status">
            <Select>
                <Option value='completed'>Bajarilgan</Option>
                <Option value='pending'>Kutilmoqda</Option>
                <Option value='failed'>Bekor qilingan</Option>
            </Select>
        </Form.Item>
        <Form.Item name={'transaction_date'} label="Bajarilgan vaqti">
            <Input type='date' />
        </Form.Item>
        <Form.Item name={'description'} label="Izoh">
            <TextArea />
        </Form.Item>
        <Form.Item>
            <Button type='primary' htmlType='submit'>Qo'shish</Button>
        </Form.Item>
    </Form>
    );
}

export default Edit;